import React, { useRef } from "react";
import "./text-line-overflow.less";
import { Tooltip } from "antd";

export default function TextLineOverflow({ text, line = "2" }) {
    const ref = useRef();
    return (
        <div className={"text-line-overflow"}>
            <Tooltip title={text}>
                <div className={"text-line-overflow clamp-text"} style={{ WebkitLineClamp: `${line}` }} ref={ref}>
                    {text}
                </div>
            </Tooltip>
        </div>
    );
}
